import theme from '../../themes/theme';

const {
  Layout: { seconday_title },
} = theme;

export default {
  itemDivider: {
    paddingLeft: '0.5em',
    color: seconday_title,
    height: '2.9em',
  },
  itemDividerIcon: {
    height: '1.5em',
    width: '1.5em',
  },
  itemDividerText: {
    display: 'inline',
    paddingLeft: '0.5em',
    fontSize: '1.25em',
  },
};
